module.exports = __webpack_public_path__ + "static/media/image-effect-preview-chat.4b8696fa.png";